import { render } from "./noticeBell.vue?vue&type=template&id=26e7dfb2&scoped=true"
import script from "./noticeBell.vue?vue&type=script&lang=js"
export * from "./noticeBell.vue?vue&type=script&lang=js"

import "./noticeBell.vue?vue&type=style&index=0&id=26e7dfb2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e7dfb2"]])

export default __exports__